// import nodeUuid from 'node-uuid';
// import { emitSearch } from './search-socket';
import { fetchSearchWithCancel } from './fetch-search';
import createAction from '../services/create-action';
// import { addRecentSearchWithCancel } from './search-history';

export const SEARCH = 'search/SEARCH';
export const SEARCH_QUERY_SEND = 'search/QUERY_SEND';
export const SEARCH_CLEAR_RESULTS = 'search/CLEAR_RESULTS';

export const MIN_QUERY_LENGTH = 2;

export const clearSearchResults = createAction(SEARCH_CLEAR_RESULTS);

export default function search(query, minQueryLength = MIN_QUERY_LENGTH) {
  return dispatch => {
    dispatch({
      type: SEARCH,
      payload: query,
    });

    // dispatch(addRecentSearchWithCancel(query));

    // if (getState().socket.connected) {
    //   const uuid = nodeUuid.v1();
    //   dispatch({
    //     type: SEARCH_QUERY_SEND,
    //     payload: {
    //       query,
    //       uuid
    //     }
    //   });
    //   dispatch(emitSearch(query, uuid));
    //   return;
    // }

    dispatch(fetchSearchWithCancel(query, 300, minQueryLength));
    if (query.length < minQueryLength) {
      dispatch(clearSearchResults());
    }
  };
}



// WEBPACK FOOTER //
// ./app/actions/search.js